import {
  defaultLoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import { createContext, useMemo } from 'react';
import type { DeliveryContext } from '~/contracts/vdp';

const defaultContext = {
  deliveryContext: defaultLoadableState<Partial<DeliveryContext>>({})
};

const LocationContext = createContext(defaultContext);

export type ContextType = typeof defaultContext;

export function LocationContextProvider({ children }) {
  const deliveryContext = useLoadableState<Partial<DeliveryContext>>({});

  const value = useMemo<ContextType>(
    () => ({
      deliveryContext
    }),
    [deliveryContext]
  );

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
}

LocationContextProvider.displayName = 'LocationContextProvider';

export default LocationContext;
